import './style.css';
import { StrictMode } from 'react';

import { removeAll } from '@moniebook-web/utils';
import * as ReactDOM from 'react-dom/client';

import App from './app/app';
import { GHOST_SESSION_PAGES } from './features/ghost-session/constants';
import { prefetchCriticalRoutes } from './shared/prefetch-critical-routes';

window.__HOST_VERSION__ = __HOST_VERSION__;

window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    window.location.reload(); // refreshes page when a new deployment is spotted
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    <StrictMode>
        <ClearTokensForGhostSession />
        <App />
    </StrictMode>,
);

function ClearTokensForGhostSession() {
    // Clear any existing tokens before the providers mount when landing
    // on the ghost session init page, so a stale session isn't picked up
    if (window.location.pathname === GHOST_SESSION_PAGES.INIT) {
        removeAll();
    }

    return null;
}

prefetchCriticalRoutes();
